/**
 * @generated SignedSource<<fec6dd4610e020ef4a8652f337529ce8>>
 * @relayHash d1b4e5c8f6c37b19f17a1d33ab76d991
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d1b4e5c8f6c37b19f17a1d33ab76d991

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type UpdateLabelsForLabelableInput = {
  addLabelIds?: ReadonlyArray<string> | null | undefined;
  addLabels?: ReadonlyArray<LabelUpdateInput> | null | undefined;
  clientMutationId?: string | null | undefined;
  labelableId: string;
  removeLabelIds?: ReadonlyArray<string> | null | undefined;
};
export type LabelUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  labelId: string;
  rationale?: string | null | undefined;
  suggest?: boolean | null | undefined;
};
export type updateLabelsForLabelableRelayMutation$variables = {
  input: UpdateLabelsForLabelableInput;
};
export type updateLabelsForLabelableRelayMutation$data = {
  readonly updateLabelsForLabelable: {
    readonly labelable: {
      readonly " $fragmentSpreads": FragmentRefs<"LabelsSectionAssignedLabels">;
    } | null | undefined;
  } | null | undefined;
};
export type updateLabelsForLabelableRelayMutation$rawResponse = {
  readonly updateLabelsForLabelable: {
    readonly labelable: {
      readonly __typename: string;
      readonly __isLabelable: string;
      readonly __isNode: string;
      readonly id: string;
      readonly labels: {
        readonly edges: ReadonlyArray<{
          readonly cursor: string;
          readonly node: {
            readonly __typename: "Label";
            readonly color: string;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly nameHTML: string;
            readonly url: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type updateLabelsForLabelableRelayMutation = {
  rawResponse: updateLabelsForLabelableRelayMutation$rawResponse;
  response: updateLabelsForLabelableRelayMutation$data;
  variables: updateLabelsForLabelableRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "NAME"
    }
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateLabelsForLabelableRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateLabelsForLabelablePayload",
        "kind": "LinkedField",
        "name": "updateLabelsForLabelable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "labelable",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LabelsSectionAssignedLabels"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateLabelsForLabelableRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateLabelsForLabelablePayload",
        "kind": "LinkedField",
        "name": "updateLabelsForLabelable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "labelable",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isLabelable"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "LabelConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nameHTML",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "MetadataSectionAssignedLabels_labels",
                "kind": "LinkedHandle",
                "name": "labels"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d1b4e5c8f6c37b19f17a1d33ab76d991",
    "metadata": {},
    "name": "updateLabelsForLabelableRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "450aaaa7e561ede05f9fc306800eb902";

export default node;
